import PropTypes from 'prop-types'

import { Box } from '@redriverpress/system'

function ErrorWrapper({ children }) {
  return (
    <Box role='alert' mt={1} fontSize={0} color='red900'>
      {children}
    </Box>
  )
}

ErrorWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ErrorWrapper
